import { render, staticRenderFns } from "./arrow-left.vue?vue&type=template&id=2d3f4762&scoped=true"
import script from "./arrow-left.vue?vue&type=script&lang=js"
export * from "./arrow-left.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f4762",
  null
  
)

export default component.exports